import React from "react";
import { connect } from "react-redux";
import { withStyles, makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import { checkForUpdates } from "../reducers/AppInfoReducer";
import IconAms from "../assets/images/icon-AMS.svg";
import ptsLogo from "../assets/images/PTS-logo.png";
import { Card, CardContent, useTheme } from "@mui/material";

const useStyles = makeStyles(() => ({
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    textAlign: "center",
    width: 480,
    minHeight: 150,
    padding: "0px",
  },
  card: {
    width: 480,
    background: "fff",
    "& img": {
      width: "100%",
    },
  },
  branding: {
    width: "100%",
    height: 200,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#52134E",
    "& img": {
      width: 150,
      height: "auto",
    },
  },
  branding2: {
    width: "100%",
    textAlign: "center",
    padding: "25px 0 5px",
    "& img": {
      height: 50,
      width: "auto",
    },
  },
  actions: {
    textAlign: "center",
    marginTop: 15,
    "& button": {
      background: "#52134E",
      color: "#fff",
      paddingLeft: "4em",
      paddingRight: "4em",
      textTransform: "uppercase",
      "&:hover": {
        background: "#9D5FCC",
      },
    },
  },
  footer: {
    fontSize: 13,
    display: "flex",
    justifyContent: "center",
    alignItems: "end",
    "& p": {
      marginBottom: 0,
    },
  },
  action: {
    marginBottom: 10,
  },
}));

const CustomDialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(DialogContent);

function AboutDialog(props) {
  const classes = useStyles();
  const theme = useTheme();
  const {
    apiVersion,
    buildNo,
    buildTime,
    availBuildNo,
    availBuildTime,
    appVersion,
  } = props.appInfo;
  const updateAvail = buildNo !== availBuildNo || buildTime !== availBuildTime;

  React.useEffect(() => {
    props.checkForUpdates();
  }, []);

  const reload = () => {
    window.location.reload(true);
  };

  return (
    <Dialog onClose={props.close} open={true}>
      <CustomDialogContent dividers className="p-0">
        <Card className={classes.card}>
          <div className={classes.branding}>
            <img src={IconAms} alt="AMS Icon" />
          </div>
          <div className={classes.branding2}>
            <img src={ptsLogo} alt="PTS logo" />
          </div>
          <CardContent>
            <div className={classes.content}>
              <div className={classes.body}>
                <p>
                  App Version: {appVersion} <br /> Api version: {apiVersion}{" "}
                  <br /> Build no: {buildNo} <br /> Build date: {buildTime}{" "}
                  <br />
                  {updateAvail && <span>(update available)</span>}
                  {!updateAvail && <span>(up to date)</span>}
                </p>
                {updateAvail && (
                  <div className={classes.action}>
                    <Button
                      size="small"
                      variant="outlined"
                      className={classes.margin}
                      onClick={reload}
                      sx={{ color: "#52134E", borderColor: "#52134E" }}
                    >
                      Reload
                    </Button>
                  </div>
                )}
                <div className={classes.actions}>
                  <Button
                    variant="contained"
                    size="large"
                    className="my-2"
                    onClick={props.close}
                  >
                    Close
                  </Button>
                </div>
              </div>
              <div className={classes.footer}>
                <p>
                  &copy; {new Date().getFullYear()}{" "}
                  <a
                    href="https://ptssolutions.com"
                    style={{
                      color: theme.palette.mode === "dark" ? "#fff" : "#000",
                      textDecoration: "underline",
                    }}
                  >
                    ptssolutions.com
                  </a>
                  , All Rights Reserved
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </CustomDialogContent>
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  return {
    appInfo: state.appInfo,
  };
};

export default connect(mapStateToProps, { checkForUpdates })(AboutDialog);
